/**
 * @generated SignedSource<<1de144f496bd9d2b5804ca4d2c8d80d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoCarousel_photos$data = ReadonlyArray<{
  readonly id: string;
  readonly serviceId: string | null;
  readonly path: string | null;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"usePhotosLikeDataRefetch_photos" | "SbSharedInteriorsHeartWrapper_photo">;
  readonly " $fragmentType": "SbRespInteriorsPhotoCarousel_photos";
}>;
export type SbRespInteriorsPhotoCarousel_photos$key = ReadonlyArray<{
  readonly " $data"?: SbRespInteriorsPhotoCarousel_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespInteriorsPhotoCarousel_photos">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespInteriorsPhotoCarousel_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePhotosLikeDataRefetch_photos"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsHeartWrapper_photo"
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};

(node as any).hash = "0898ed565145489f6e73aa06d2775ce7";

export default node;
